<!-- Header -->
 <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" style="margin: -24px;">
    <div class="text-lg font-medium">BOM Details - {{ bom.productName }}</div>
    <button
        mat-icon-button
        (click)="dialogRef.close()"
        [tabIndex]="-1">
        <mat-icon
            class="text-current"
            [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
</div>

<!-- Content -->
<mat-dialog-content class="mat-typography mt-12">
  <div class="flex flex-col gap-6">

    <!-- BOM Header Information -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="bg-gray-50 border rounded-xl p-4">
        <h4 class="text-lg mb-3 text-black">Product Details</h4>
        <div class="grid grid-cols-2 gap-2 text-md">
          <span class="text-secondary">BOM Ref:</span>
          <span class="text-right text-black">BOM-{{bom.createdDate | date:'yyyy'}}-{{bom.bomId?.toString().padStart(3, '0')}}</span>

          <span class="text-secondary">Part Number:</span>
          <span class="text-right text-black">{{bom.productName}}</span>

          <span class="text-secondary">Description:</span>
          <span class="text-right text-black">{{bom.productDescription}}</span>

          <span class="text-secondary">Type:</span>
          <span class="text-right text-black">{{bom.isMultiLevel ? 'Multi' : 'Single'}}-Level BOM</span>

          <span class="text-secondary">Revision:</span>
          <span class="text-right text-black">{{bom.revision | number:'1.1'}}</span>
        </div>
      </div>

      <div class="bg-gray-50 border rounded-xl p-4">
        <h4 class="text-lg mb-3 text-black">Status & Approval</h4>
        <div class="grid grid-cols-2 gap-2 text-md">
          <span class="text-secondary">Status:</span>
          <span class="text-right">
            <span class="px-3 py-1 rounded-full text-sm uppercase"
                  [style.background-color]="getStatusColor() === 'green' ? '#E7F8F2' :
                                            getStatusColor() === 'orange' ? '#FEF5E6' :
                                            getStatusColor() === 'red' ? '#FDECEC' : '#EFEFEF'"
                  [style.color]="getStatusColor()">
              {{getStatusText()}}
            </span>
          </span>

          <span class="text-secondary">Created:</span>
          <span class="text-right text-black">{{bom.createdDate | date:'dd MMM yyyy'}}</span>

          <span class="text-secondary">Creator:</span>
          <span class="text-right text-black">{{data.creatorName || '-'}}</span>

          <ng-container *ngIf="bom.approvalDate">
            <span class="text-secondary">Approval Date:</span>
            <span class="text-right text-black">{{bom.approvalDate | date:'dd MMM yyyy'}}</span>

            <span class="text-secondary">Approver:</span>
            <span class="text-right text-black">{{data.approverName || '-'}}</span>
          </ng-container>

          <div class="col-span-2"></div>
          <span class="font-semibold">Total Cost:</span>
          <span class="text-right font-semibold text-black">{{getGrandTotal() * 1.05 | currency:'GBP'}}</span>
        </div>
      </div>
    </div>

    <!-- BOM Items Table -->
    <div>
      <h3 class="text-xl text-black mb-3">BOM Structure</h3>
      <div class="w-full flex flex-col divide-y border rounded-xl overflow-hidden">
        <!-- Header - Desktop Only -->
        <div class="hidden md:grid grid-cols-8 bg-gray-50 border-t py-2 px-6 gap-3 items-center uppercase text-md text-black tracking-tight">
          <span>Level</span>
          <span class="col-span-1">Part Number</span>
          <span class="col-span-3">Description</span>
          <span>Qty</span>
          <span>Unit Cost</span>
          <span class="text-right">Total Cost</span>
        </div>

        <!-- Rows -->
        <ng-container *ngIf="bomItems?.length">
          <ng-container *ngFor="let item of bomItems">
            <!-- Desktop Row -->
            <div class="hidden md:grid grid-cols-8 py-2 px-6 gap-3 items-center text-md text-black">
              <span>{{item.level}}</span>
              <span class="col-span-1">{{lookupPartFromId(item.partId)?.number || '-'}}</span>
              <span class="col-span-3 line-clamp-2">{{lookupPartFromId(item.partId)?.description || '-'}}</span>
              <span>{{item.quantity}}</span>
              <span>{{lookupPartFromId(item.partId)?.cost | currency:'GBP'}}</span>
              <span class="text-right">{{(item.quantity * (lookupPartFromId(item.partId)?.cost || 0)) | currency:'GBP'}}</span>
            </div>

            <!-- Mobile Card -->
            <div class="md:hidden flex flex-col gap-2 py-3 px-4 border-t">
              <div class="flex justify-between">
                <span class="text-secondary text-sm">Level:</span>
                <span class="font-semibold text-black">{{item.level}}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-secondary text-sm">Part Number:</span>
                <span class="text-black">{{lookupPartFromId(item.partId)?.number || '-'}}</span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="text-secondary text-sm">Description:</span>
                <span class="text-sm text-black">{{lookupPartFromId(item.partId)?.description || '-'}}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-secondary text-sm">Quantity:</span>
                <span class="text-black">{{item.quantity}}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-secondary text-sm">Unit Cost:</span>
                <span class="text-black">{{lookupPartFromId(item.partId)?.cost | currency:'GBP'}}</span>
              </div>
              <div class="flex justify-between border-t pt-2">
                <span class="text-secondary text-sm font-semibold">Total Cost:</span>
                <span class="font-semibold text-black">{{(item.quantity * (lookupPartFromId(item.partId)?.cost || 0)) | currency:'GBP'}}</span>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Empty state -->
        <ng-container *ngIf="!bomItems?.length">
          <div class="py-8 text-center text-secondary">
            No BOM items found
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Assembly Process Table -->
    <div *ngIf="bomAssemblyProcesses?.length">
      <h3 class="text-xl mb-3 text-black">Assembly Process</h3>
      <div class="w-full flex flex-col divide-y border rounded-xl overflow-hidden">
        <!-- Header - Desktop Only -->
        <div class="hidden md:grid grid-cols-12 bg-gray-50 border-t py-2 px-6 gap-3 items-center uppercase text-md tracking-tight text-black">
          <span>Seq</span>
          <span>Op Code</span>
          <span class="col-span-2">Operation Name</span>
          <span class="col-span-2">Cost Center</span>
          <span>Setup (hr)</span>
          <span>Run (hr)</span>
          <span class="col-span-2">Notes</span>
          <span class="col-span-2 text-right">Rate</span>
        </div>

        <!-- Rows -->
        <ng-container *ngFor="let process of bomAssemblyProcesses">
          <!-- Desktop Row -->
          <div class="hidden md:grid grid-cols-12 py-2 px-6 gap-3 items-center text-md text-black">
            <span>{{process.sequence}}</span>
            <span>{{process.operationCode}}</span>
            <div class="col-span-2">
              <div>{{process.operationName}}</div>
              <div *ngIf="process.isSubcontracted" class="text-xs text-orange-500">
                <mat-icon class="icon-size-3">business</mat-icon>
                {{process.subcontractorName}}
              </div>
            </div>
            <span class="col-span-2">{{getCostCentreName(process.costCentreCode)}}</span>
            <span>{{process.setupHours * (process.isSubcontracted ? 35 : 1)}}</span>
            <span>{{process.runPerUnitHours}}</span>
            <span class="col-span-2 text-sm">{{process.notes || '-'}}</span>
            <span class="col-span-2 text-right">{{getProcessRate(process) | currency:'GBP'}}</span>
          </div>

          <!-- Mobile Card -->
          <div class="md:hidden flex flex-col gap-2 py-3 px-4 border-t">
            <div class="flex justify-between">
              <span class="text-secondary text-sm">Sequence:</span>
              <span class="font-semibold text-black">{{process.sequence}}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-secondary text-sm">Op Code:</span>
              <span class="text-black">{{process.operationCode}}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-secondary text-sm">Operation Name:</span>
              <span class="text-sm text-black">{{process.operationName}}</span>
              <div *ngIf="process.isSubcontracted" class="text-xs text-orange-500 flex items-center gap-1">
                <mat-icon class="icon-size-3">business</mat-icon>
                {{process.subcontractorName}}
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-secondary text-sm">Cost Centre:</span>
              <span class="text-sm text-black">{{getCostCentreName(process.costCentreCode)}}</span>
            </div>
            <div class="grid grid-cols-2 gap-2">
              <div class="flex flex-col">
                <span class="text-secondary text-sm">Setup (hr):</span>
                <span class="text-black">{{process.setupHours * (process.isSubcontracted ? 35 : 1)}}</span>
              </div>
              <div class="flex flex-col">
                <span class="text-secondary text-sm">Run (hr):</span>
                <span class="text-black">{{process.runPerUnitHours}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-secondary text-sm">Notes:</span>
              <span class="text-sm text-black">{{process.notes || '-'}}</span>
            </div>
            <div class="flex justify-between border-t pt-2">
              <span class="text-secondary text-sm font-semibold">Rate:</span>
              <span class="font-semibold text-black">{{getProcessRate(process) | currency:'GBP'}}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Cost Summary -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="bg-gray-50 border rounded-xl p-4">
        <h4 class="text-lg mb-3 text-black">Cost Summary</h4>
        <div class="grid grid-cols-2 gap-2 text-md">
          <span class="text-secondary">Materials Cost:</span>
          <span class="text-right text-black">{{getMaterialTotal() | currency:'GBP'}}</span>

          <span class="text-secondary">Labour Cost:</span>
          <span class="text-right text-black">{{getCostCentreProcessesTotal() + getAssemblySubcontractorTotal() | currency:'GBP'}}</span>

          <span class="text-secondary">Overhead Cost (5%):</span>
          <span class="text-right text-black">{{getGrandTotal() * 0.05 | currency:'GBP'}}</span>

          <span class="col-span-2 border-b"></span>

          <span class="font-semibold">Total Cost:</span>
          <span class="text-right font-semibold text-black">{{getGrandTotal() * 1.05 | currency:'GBP'}}</span>
        </div>
      </div>

      <!-- Approval Comment (if exists) -->
      <div *ngIf="bom.approvalComment" class="bg-gray-50 border rounded-xl p-4">
        <h4 class="text-lg mb-3 text-black">Approval Comment</h4>
        <p class="text-md italic text-black">"{{bom.approvalComment}}"</p>
      </div>
    </div>

  </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions align="end" class="pt-4">
  <button
    mat-stroked-button
    class="mr-auto"
    color="accent"
    type="button"
    (click)="dialogRef.close()">
    Close
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="downloadDrawings()">
    <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:file_download'"></mat-icon>
    <span class="ml-2">Download Drawings</span>
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="editBom()">
    <mat-icon class="icon-size-5">edit</mat-icon>
    <span class="ml-2">Edit BOM</span>
  </button>
</mat-dialog-actions>
